// features/workstations/components/add-workstation-card.js
// ═══════════════════════════════════════════════════════════
// + NEW WORKSTATION tile — dashed border, "7-minute
// conversation not a form" framing. Triggers orientation
// (Phase 5) or a minimal create form for Phase 1+2.
// ═══════════════════════════════════════════════════════════

export default function AddWorkstationCard({ onClick }) {
  return (
    <button type="button" className="ws-add-tile" onClick={onClick}>
      <div className="ws-add-tile-header">+ New Workstation</div>
      <div className="ws-add-tile-title">Configure for a new kind of work</div>
      <div className="ws-add-tile-desc">
        A 7-minute conversation, not a form. Tell Shift what you do, your rules,
        your studies — the workstation builds in real time as you talk.
      </div>
      <div className="ws-add-tile-cta">Begin →</div>
    </button>
  );
}
